import { render, staticRenderFns } from "./GenerateRide.vue?vue&type=template&id=4fb88c8f&scoped=true"
import script from "./GenerateRide.vue?vue&type=script&lang=js"
export * from "./GenerateRide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb88c8f",
  null
  
)

export default component.exports